import React, { useState, useEffect } from 'react';
import { Wheel } from 'react-custom-roulette';
import ConfettiExplosion from 'react-confetti-explosion';
import { useMediaQuery } from 'react-responsive';

const ROULETTE_API_URL = 'https://roulette-qmlofqf3ja-uc.a.run.app';

export default function Roulette({ customerId, token, testToken, locale, eventName }) {
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [hasParticipated, setHasParticipated] = useState(false);
  const isMobile = useMediaQuery({ query: '(max-width: 640px)' });
  const [data] = useState([
    {
      option: '3,000P',
      image: {
        uri: locale === 'ko'
          ? 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/d89bd41f20fc1a6e94ba70e5ac2141b82e879821.png?v=1779911276'
          : 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/e2c5028af978f5f5f457171537261e9a5bf92755.png?v=1779978501',
        sizeMultiplier: 2.3,
      },
    },
    {
      option: '1,999P',
      style: { backgroundColor: '#fff', textColor: '#333' },
      image: {
        uri: locale === 'ko'
          ? 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/4225d747811e0cd3c021ac54e28b7fd836f3842c.png?v=1779911276'
          : 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/58fcd0b46951a32910055b243d2a5ee476ec3467.png?v=1779978501',
        sizeMultiplier: 2.3,
      },
    },
    {
      option: '40,000P',
      style: { backgroundColor: '#fff', textColor: '#333' },
      image: {
        uri: locale === 'ko'
          ? 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/e611b22d63fa0c5862b60a2b534dfd0fa45da11f.png?v=1779911276'
          : 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/6c60b6aa726c07130c4dc26581a33bea2b5cf95c.png?v=1779978501',
        sizeMultiplier: 2.3,
      },
    },
    {
      option: '445P',
      style: { backgroundColor: '#fff', textColor: '#333' },
      image: {
        uri: locale === 'ko'
          ? 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/9872ddac9faa7a2ed536b73ff8497b5d0d298383.png?v=1779986511'
          : 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/433ce0cc31ad1762a52cf9eb52a9a6267a2f6d3f.png?v=1779978501',
        sizeMultiplier: 2.3,
      },
    },
    {
      option: '50P',
      style: { backgroundColor: '#fff', textColor: '#333' },
      image: {
        uri: locale === 'ko'
          ? 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/16f6b74baa068bfa7c1c079259ab05c5e1a6690d.png?v=1779987785'
          : 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/2f6e82bc80b3726b60a96c5b877eac823e4170fd.png?v=1779987785',
        sizeMultiplier: 2.3,
      },
    },
    {
      option: '5,000P',
      style: { backgroundColor: '#fff', textColor: '#333' },
      image: {
        uri: locale === 'ko'
          ? 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/1539ab18e04ea0f265cb118aa085fe43861b97ed.png?v=1779987785'
          : 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/b87be89f40988fc34e15803639fd5a7b9d660c5e.png?v=1779987785',
        sizeMultiplier: 2.3,
      },
    },
    {
      option: '60,000P',
      style: { backgroundColor: '#fff', textColor: '#333' },
      image: {
        uri: locale === 'ko'
          ? 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/3b582fdec22df3c4faa3a7412995e35624ffdac3.png?v=1779911276'
          : 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/1dcdf2596d28f6f5c573793b907113a66f48ce7f.png?v=1779978501',
        sizeMultiplier: 2.3,
      },
    },
    {
      option: '25,000P',
      style: { backgroundColor: '#fff', textColor: '#333' },
      image: {
        uri: locale === 'ko'
          ? 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/a5cd04b87160963857cae17061ff7a35905db0b0.png?v=1779987700'
          : 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/1a70f45342ed1744f98bce39942c7b8c7563f753.png?v=1779987700',
        sizeMultiplier: 2.3,
      },
    },
  ]);

  // useEffect(() => {
    // const initRoulette = async () => {
    //   if (customerId && token) {
    //     try {
    //       const response = await fetch(ROULETTE_API_URL, {
    //         method: 'GET',
    //         headers: {
    //           'Content-Type': 'application/json',
    //           'x-test-token': testToken,
    //           'x-event-name': eventName,
    //           Authorization: `${token}`,
    //         },
    //       });
    //
    //       const resultData = await response.json();
    //
    //       if (resultData?.spin?.rewardIndex !== undefined) {
    //         setHasParticipated(true);
    //       }
    //     } catch (err) {
    //       console.error('초기화 실패:', err);
    //     } finally {
    //     }
    //   }
    // };
    // initRoulette();
  // }, [customerId, token]);

  const handleSpinClick = async () => {
    if (!customerId) {
      window.location.href = '/account/login';
      return;
    }

    if (mustSpin || isLoading) return;

    if (hasParticipated) {
      alert('룰렛은 1일 1회 참여 가능합니다. 내일 또 참여해 주세요.');
      return;
    }

    setIsLoading(true);
    setResult(null);

    try {
      const response = await fetch(ROULETTE_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
          'x-event-name': eventName,
          'x-test-token': testToken,
          'x-locale': locale,
        },
        body: JSON.stringify({ customerId }),
      });

      const resultData = await response.json();

      if (!response.ok) {
        if (resultData?.error === 'Already participated today') {
          alert('이미 참여하셨습니다.');
          setHasParticipated(true);
          return;
        }
        throw new Error('서버 오류');
      }

      const rewardIndex = resultData?.spin?.rewardIndex;

      if (typeof rewardIndex === 'number') {
        setPrizeNumber(rewardIndex);
        setMustSpin(true);
      } else {
        throw new Error('잘못된 응답입니다.');
      }
    } catch (error) {
      console.error('Spin error:', error);
      alert('룰렛을 돌릴 수 없습니다.');
      console.error('Spin error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleStopSpinning = () => {
    if (typeof prizeNumber !== 'number' || isNaN(prizeNumber)) {
      console.error('Invalid prizeNumber:', prizeNumber);
      return;
    }

    const reward = data[prizeNumber];

    if (!reward) {
      console.error('Invalid reward index:', prizeNumber, 'data length:', data.length);
      return;
    }

    setResult(reward.option);
    setMustSpin(false);
    setIsLoading(false);
  };

  const resetRoulette = () => {
    setResult(null);
    setPrizeNumber(0);
  };

  const adjustedPrizeNumber = (prizeNumber + 1) % data.length;

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="parent-container relative mt-10 w-[92vw] h-[92vw] md:w-[590px] md:h-[590px] mx-auto flex items-center justify-center">
        {/* 스핀 버튼 */}
        <div className=" absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 flex items-center justify-center">
          <button
            onClick={handleSpinClick}
            disabled={mustSpin || isLoading}
            className={`
              rounded-full shadow-lg z-20 w-[100px] h-[100px] lg:w-[150px] lg:h-[150px]
              ${mustSpin || isLoading ? 'cursor-not-allowed' : ''}
              transition-all duration-200 transform hover:scale-105
            `}
          >
            <span className="absolute inset-0 flex items-center justify-center">
              {isLoading ? (
                <div className="animate-spin w-6 h-6 border-2 border-white border-t-transparent rounded-full mx-auto"></div>
              ) : (
                <img
                  className="animate-pulse"
                  src="https://cdn.shopify.com/s/files/1/0528/8266/9745/files/e0f0a08d9f9b76cd0001e178670ad66ee937db35.png?v=1779894489"
                />
              )}
            </span>
          </button>
        </div>

        <div
          className="absolute bg-white w-[104%] h-[104%] rounded-full"
          style={{
            boxShadow: '1px 0px 8.1px 0px #00000040',
          }}
        ></div>
        <div
          className="absolute border-[10px] border-[#86C9F7] rounded-full z-10"
          style={{
            height: '92%',
            width: '92%',
          }}
        />
        <img
          className="absolute z-20 w-[50px] sm:w-[66px] h-[70px] sm:h-[96px] top-[-22px] sm:top-[-32px]"
          src="https://cdn.shopify.com/s/files/1/0528/8266/9745/files/51738fce9cf5a797110ef7c52fde1b1ce27ac000.png?v=1779894031"
        />
        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={adjustedPrizeNumber}
          data={data}
          onStopSpinning={handleStopSpinning}
          textColors={['#333']}
          outerBorderColor={'transparent'}
          backgroundColors={['#FFF8F0', '#FFF0E6']}
          outerBorderWidth={1}
          // fontFamily={'GmarketSans'}
          radiusLineWidth={0}
          // radiusLineColor={"black"}
          // innerBorderWidth={1}
          // innerBorderColor={'#fd790e'}
          fontSize={20}
          fontWeight={700}
          perpendicularText={true}
          // textDistance={55}
          spinDuration={0.5}
          pointerProps={{
            src: 'https://cdn.shopify.com/s/files/1/0528/8266/9745/files/51738fce9cf5a797110ef7c52fde1b1ce27ac000.png?v=1779894031',
            style: {
              position: 'absolute',
              top: isMobile ? '-22px' : '-32px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 50,
              width: isMobile ? '50px' : '66px',
              height: isMobile ? '70px' : '96px',
            },
          }}
        />
      </div>

      {/* 결과 표시 */}
      {result && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 animate-fadeIn"
          onClick={resetRoulette}
        >
          <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-[90%] text-center border-t-[6px] border-[#F15837] transform scale-100 animate-scaleIn">
            <h2 className="text-3xl font-extrabold text-[#F15837] mb-3">
              {locale === 'ko' ? '🎉 축하드립니다!' : '🎉 Congratulations!'}
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              <span className="text-2xl font-bold text-gray-900 block mt-2">{result}</span>
            </p>
            <a
              href="/collections/best-sellers"
              className="inline-block w-full py-3 px-6 bg-[#F15837] text-white rounded-xl font-semibold text-base hover:bg-orange-500 transition-colors"
            >
              {locale === 'ko' ? '쇼핑하러 가기' : 'Shop Now'}
            </a>
            <button
              onClick={resetRoulette}
              className="mt-2 w-full py-3 px-6 bg-gray-100 text-gray-700 rounded-xl font-semibold text-base hover:bg-gray-200 transition-colors"
            >
              {locale === 'ko' ? '닫기' : 'Close'}
            </button>
            <div className="flex flex-row justify-center w-full">
              <ConfettiExplosion force={0.4} duration={2200} particleCount={30} width={400} zIndex={9999} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}